const BASE = '/v1/inventory';

export default (instance) => ({
  getTransactionTypes: () =>
    instance.get(`${BASE}/transaction-types`),

  getAll: (params = {}) =>
    instance.get(BASE, { params }),

  adjust: (payload) =>
    instance.post(`${BASE}/adjust`, payload),

  getTransactions: (params = {}) =>
    instance.get(`${BASE}/transactions`, { params }),

  getAllocationsByOrderLine: (orderLineId) =>
    instance.get(`${BASE}/allocations/by-order-line/${orderLineId}`),

  createAllocation: (payload) =>
    instance.post(`${BASE}/allocations`, payload),

  issueAllocation: (allocationId, payload) =>
    instance.post(`${BASE}/allocations/${allocationId}/issue`, payload)
});
